import { IEmailTemplateAttachment } from "../../../data/graphQL/types";

export interface IAttachmentFile {
    ID?: number;
    File: File;
    ProcessingStatus: FileProcessingStatus;
}

// Model to manipulate template attachments when sending emails.
// BulkEmailWizardViewModel
export interface IAttachmentStatus {
    RecordAttachmentID: number;
    Description: string;
    ToBeDeleted: boolean;
}

// Model for manipulating template attachments through graphQL
export interface ITemplateAttachment {
    id: number;
    name: string;
    toBeDeleted: boolean;
}

export enum FileProcessingStatus {
    Pending,
    Uploading,
    Uploaded,
    Deleting,
    Deleted,
    Errored,
}

export const mapTemplateAttachments = (templateAttachments: IEmailTemplateAttachment[]): IAttachmentFile[] => {
    const initialAttachments: IAttachmentFile[] = [];

    for (let i = 0; i < templateAttachments.length; i++) {
        const attachment = templateAttachments[i];
        initialAttachments.push({
            ID: attachment.id,
            File: new File([new ArrayBuffer(attachment.size)], attachment.name),
            ProcessingStatus: FileProcessingStatus.Uploaded,
        });
    }

    return initialAttachments;
};

export const mapAttachmentFileToSimpleAttachments = (templateAttachments: IAttachmentFile[]): IAttachmentStatus[] => {
    const simpleAttachmentCollection: IAttachmentStatus[] = [];

    for (let index = 0; index < templateAttachments.length; index++) {
        const attachment = templateAttachments[index];
        simpleAttachmentCollection.push({
            RecordAttachmentID: attachment.ID || -1,
            Description: attachment.File.name,
            ToBeDeleted: attachment.ProcessingStatus === FileProcessingStatus.Deleted,
        });
    }

    return simpleAttachmentCollection;
};

export const mapAttachmentFileToTemplateAttachments = (templateAttachments: IAttachmentFile[]): ITemplateAttachment[] => {
    const templateAttachmentCollection: ITemplateAttachment[] = [];

    for (let index = 0; index < templateAttachments.length; index++) {
        const attachment = templateAttachments[index];
        templateAttachmentCollection.push({
            id: attachment.ID || -1,
            name: attachment.File.name,
            toBeDeleted: attachment.ProcessingStatus === FileProcessingStatus.Deleted,
        });
    }

    return templateAttachmentCollection;
};

export * from "./AttachmentInput";
export * from "./AttachmentList";
export * from "./AttachmentListItems";
